import { render, staticRenderFns } from "./CPFetchingOverlay.vue?vue&type=template&id=20ef3a48&"
import script from "./CPFetchingOverlay.vue?vue&type=script&lang=ts&"
export * from "./CPFetchingOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./CPFetchingOverlay.vue?vue&type=style&index=0&id=20ef3a48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports